import { sendGet, sendPost } from "./generic"

export const getAgencies = () => {
    return sendGet(`Admin/Agencies`)
}

export const getAgenciesByPagination = ({ pageIndex, numberOfRecords, orderBy, parentDescending, childDescending }) => {
    return sendGet(`Admin/Agencies/${pageIndex}/${numberOfRecords}/${orderBy}/${parentDescending}/${childDescending}`)
}

export const searchAgenciesByPagination = ({
    searchTerm,
    searchIn,
    pageIndex,
    numberOfRecords,
    orderBy,
    parentDescending,
    childDescending
}) => {
    return sendGet(
        `Admin/Agencies/${searchTerm}/${searchIn}/${pageIndex}/${numberOfRecords}/${orderBy}/${parentDescending}/${childDescending}`
    )
}

export const addAgency = (payload) => {
    return sendPost(`Admin/Agencies`, payload)
}

export const editAgency = (payload) => {
    return sendPost(`Admin/Agencies`, payload)
}

export const exportAgencies = (payload) => {
    return sendGet(`Admin/Agencies/Export`)
}

export const getAgencyList = () => {
    return sendGet(`Admin/Agencies/List`)
}

export const getContactsByAgency = (id) => {
    return sendGet(`Admin/Agencies/${id}/Contacts`)
}

export const getAgencyById = (id) => {
    return sendGet(`Admin/Agencies/${id}`)
}
